import React, { createContext, useState, useCallback, useEffect, useMemo } from "react";
import { setGlobalErrorHandler } from "./globalErrorBridge";

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [errorState, setErrorState] = useState({
    isOpen: false,
    message: "Something went wrong, please try again later",
  });

  const showError = useCallback((message = "Something went wrong, please try again later") => {
    setErrorState({
      isOpen: true,
      message: message,
    });
  }, []);

  const closeError = useCallback(() => {
    setErrorState({
      isOpen: false,
      message: "Something went wrong, please try again later",
    });
  }, []);

  useEffect(() => {
    setGlobalErrorHandler(showError);
    return () => {
      setGlobalErrorHandler(null);
    };
  }, [showError]);

  const value = useMemo(
    () => ({ errorState, showError, closeError }),
    [errorState, showError, closeError]
  );

  return <ErrorContext.Provider value={value}>{children}</ErrorContext.Provider>;
};

export const useGlobalError = () => {
  const context = React.useContext(ErrorContext);
  if (!context) {
    throw new Error("useGlobalError must be used within ErrorProvider");
  }
  return context;
};
